const color = {
  ippd: "#77bbdb",
  ippdDarker: "#17406f",
  white: "#f5f5f6",
  black: "#343844",

  th: "#4281A1",
  kr: "#D5514A",
  my: "#EAB835",
  vn: "#5D7E0F",
  id: "#3D3D3D",
  af: "#b3b3b3",
  nasa: "#b3b3b3",
  asoc: "#b3b3b3",
  eu: "#b3b3b3"
};

export default color;

const COLOR_DICT = {
  ไทย: color.th,
  เกาหลีใต้: color.kr,
  มาเลเซีย: color.my,
  เวียดนาม: color.vn,
  อินโดนีเซีย: color.id,
  แอฟริกา: color.af,
  อเมริกา: color.nasa,
  "เอเชีย & โอเชียเนีย": color.asoc,
  ยุโรป: color.eu
};

const Color = country => COLOR_DICT[country];

export { COLOR_DICT, Color };

const REG_COLOR_DICT = {
  "การห้ามผลิต แจก ใช้ และ/หรือ ซื้อขายอย่างเด็ดขาดหรือบางส่วน": "#61bddf",
  เครื่องมือทางเศรษฐศาสตร์: "#89bf67",
  การผสมกันระหว่างเครื่องมือทางเศรษฐศาสตร์และการห้าม: "#a685cd",
  ข้อตกลงระหว่างภาครัฐและภาคเอกชน: "#f6916b"
};
const RegulationActionColor = type => REG_COLOR_DICT[type];

export { REG_COLOR_DICT, RegulationActionColor };
